<template>
  <v-jumbotron>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h4 class="display-2 my-3">
            Evaluation
          </h4>
<!--           <span class="subheading">
            <h3>Info about the Challenge</h3>
          </span> -->
          <span class="subheading">
            <p>When you are ready to submit your container for evaluation, use the <v-btn flat color="primary" to="submit" class="mx-0 my-0">Submit</v-btn> link in the navigation menu. You can submit a container from Docker Hub or any other repository that exposes the proper container API, such as the container registry service from a cloud provider.</p>

            <p>Check the status of your submissions at any time using <v-btn color="primary" flat to="submissions" class="mx-0 my-0">My submissions</v-btn> link in the toolbar at top right. Refer to  the <v-btn color="primary" flat to="tutorial" class="mx-0 my-0">Tutorial</v-btn> for more about the submissions process.</p>
          
          </span>
          <v-divider></v-divider>
          <!-- <div class="title my-4">?</div> -->
          <v-btn color="primary" dark class="mx-0 my-4" to="tour5">Next</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>

</template>

<script>
  export default {
    name: 'Tour4',
    data () {
      return {
        // foo: 'bar'
        // gradient: '315deg, #3f87a6, #f69d3c',
      }
    },
    mounted () {
      // console.log('Tour3 component mounted')
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Tour/Tour4.vue